import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import { IDmvSearchResult } from '../business-objects/types';

// types
export enum DmvSearchActionTypes {
  SEARCH = '@@dmvsearch/SEARCH',
  GET_IMAGE = '@@dmvsearch/GET_IMAGE',
}

export const dmvSearch = (url: string) => {
  return async (dispatch) => {
    try {
      Api.get(url).then((result: ApiResponse<any>) => {
        dispatch(reduceResults(result.data.results));
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const reduceResults = (result: IDmvSearchResult[]) => {
  return {
    type: DmvSearchActionTypes.SEARCH,
    value: result,
  };
};
